<a class="popular-links-card" (click)="goTo(card.link); clickPopularLinksEvent(card.link)">
  <div
    [title]="card.image.title"
    [attr.aria-label]="card.image.alt"
    class="popular-links-card__image-container"
    [style.background-image]="'url(' + (card.image.filename + sbFormatParam) + ')'"
  ></div>
  <div class="popular-links-card__text-container">
    {{ card.title }}
  </div>
</a>
